import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
} from '@lightspeed/design-system-react'
import React, { FC, useCallback, useEffect } from 'react'
import { T } from '@transifex/react'
import { trackUserEvent } from '@vend/utilities'
import { useSaleCalculationComplete } from '../../../ng-compat/hooks'
import { WEB_REGISTER } from '../../web-register.constant'

interface Props {
  saleId: string
  close: (val: Promise<boolean>) => void
}

export const LSPayRecoveryModal: FC<Props> = ({ saleId, close }) => {
  const saleCalculationCompleted = useSaleCalculationComplete()

  const sendUserEvent = useCallback(
    (eventName: string) => {
      trackUserEvent(WEB_REGISTER.DISPLAY_NAME, eventName, {
        saleId,
      })
    },
    [saleId]
  )
  const onContinue = () => {
    sendUserEvent('LSPay Recovery Modal: clicked on udate payment status')
    close(Promise.resolve(true))
  }
  useEffect(() => {
    sendUserEvent('Open LSPay Recovery Modal')
  }, [sendUserEvent])

  useEffect(() => {
    const handleBeforeUnload = () => {
      if (!saleCalculationCompleted) {
        // We want to track the behavior of page refreshes or tab closures when the recovery modal is displayed.
        // This could occur because the update status button might get stuck in loading for a while, especially in certain edge cases.
        sendUserEvent('Close LSPay Recovery Modal on page unload')
      }
    }
    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [sendUserEvent, saleCalculationCompleted])

  return (
    <Modal size="small">
      <ModalHeader>
        <T
          _str="Hold up! You have a pending payment status."
          _context="Payment Recovery Modal Title"
        />
      </ModalHeader>
      <ModalContent>
        <p className="vd-p">
          <T
            _str="Your recent sale was dismissed or disrupted during payment processing. You can update the payment status to complete the sale."
            _context="Payment Recovery Modal Content"
          />
        </p>
      </ModalContent>
      <ModalActions>
        <div className="vd-btn-group">
          <Button
            variant="go"
            onClick={onContinue}
            autoFocus
            loading={!saleCalculationCompleted}
            data-track="update-payment-status"
          >
            <T
              _str="Update payment status"
              _context="Payment recovery action"
            />
          </Button>
        </div>
      </ModalActions>
    </Modal>
  )
}
